import { CatalogCategoriesPage } from "./CatalogCategoriesPage";

const CatalogCategories = () => {
	return <CatalogCategoriesPage />;
};

export default CatalogCategories;
